import { memo } from "react";
import ChangePassword from "./change-password";
import TwoVerification from "./two-verification/two-verification";

const PasswordSetting = () => {
    return (
        <div className="m-container">
            <ChangePassword />
            <TwoVerification />
        </div>
    )
}

export default memo(PasswordSetting);